/* eslint linebreak-style: ["error", "unix"] */
import { APP_ROUTES, ModalQueryParams } from 'data/app';
import BackofficeFactory, { BackofficeFeature } from 'components/backoffice-factory/backoffice-factory';
import {
  deleteUserGql, listUsersGql, updateUserGql,
} from 'data/users';
import { formatToDateAndHour } from 'utils/formatters';
import { useSnackbar } from 'notistack';
import { useMutation } from '@apollo/client';
import { formatGraphqlErrorMessage } from 'libs/graphql/graphql-error-formatters';
import SendEmailNotificationForNonActivePartners from 'components/buttons/button-remove-old-product-orders/send-email-notification-for-non-active-partners';
import { makeStyles } from '@material-ui/core';

export default function ManageUsersPage() {
  const { enqueueSnackbar } = useSnackbar();
  const useStyles = makeStyles(() => ({
    emailNotification: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
  }));
  const [mutate] = useMutation(updateUserGql, {
    onError: (error) => {
      enqueueSnackbar(formatGraphqlErrorMessage(error), { variant: 'error' });
    },
    onCompleted: () => {
      enqueueSnackbar('Dado atualizado com sucesso', { variant: 'success' });
    },
  });

  const userFeature: BackofficeFeature = {
    name: 'Utilizadores',
    url: APP_ROUTES.backoffice.users.manageUsers,
    listQuery: listUsersGql,
    listQuerySelector: 'listUsers',
    deleteMutation: deleteUserGql,
    columns: [
      {
        headerName: 'ID',
        field: 'id',
        width: 75,
      },
      {
        headerName: 'Nrº Sócio',
        field: 'membershipNumber',
        width: 110,
        editable: true,
        type: 'number',
      },
      {
        headerName: 'Nome de utilizador',
        field: 'username',
        flex: 1,
      },
      {
        headerName: 'E-mail',
        field: 'email',
        flex: 1,
      },
      {
        headerName: 'Registado em',
        field: 'createdAt',
        flex: 1,
        valueFormatter: (params) => formatToDateAndHour(params.value?.toString()),
      },
      {
        headerName: 'Último início de sessão',
        field: 'lastLoginAt',
        flex: 1,
        valueFormatter: (params) => formatToDateAndHour(params.value?.toString()),
      },
    ],
    // onEditCellChange: (params) => {
    //   const { field } = params;
    //   let { value } = params.props;

    //   const { id } = params;
    //   const isNumberField = field === 'membershipNumber';

    //   if (isNumberField) {
    //     value = Number(value);
    //   }

    //   mutate({
    //     variables: {
    //       input: {
    //         id,
    //         [field]: value,
    //       },
    //     },
    //   });
    // },
    VIEW_QUERY_PARAM: ModalQueryParams.VIEW_USER,
    ADD_QUERY_PARAM: ModalQueryParams.CREATE_USER,
    UPDATE_QUERY_PARAM: ModalQueryParams.EDIT_USER,
    addLabel: 'Criar / Importar utilizadores',
    searchTextFilterKey: 'email',
    searchTextPlaceholder: 'Pesquisar email...',
  };

  const classes = useStyles();

  return (
    <BackofficeFactory
      features={[
        userFeature,
      ]}
    >
      <div className={classes.emailNotification}><SendEmailNotificationForNonActivePartners /></div>
    </BackofficeFactory>
  );
}
